import { jsx as r } from "react/jsx-runtime";
import l from "classnames";
import { Wrapper as m, Container as c } from "./styled.js";
const u = ({
  children: a,
  showFooter: t = !1,
  showLoading: e = !1,
  contentPadding: n = 32,
  backgroundColor: i = "",
  mainBackgroundColor: s = "",
  className: o = "",
  hasTitle: d = !0
}) => /* @__PURE__ */ r(
  m,
  {
    $mainBackgroundColor: s,
    className: l({ [o]: !!o }),
    children: /* @__PURE__ */ r(
      c,
      {
        $contentPadding: n,
        $showLoading: e,
        $showFooter: t,
        $backgroundColor: i,
        $hasTitle: d,
        children: a
      }
    )
  }
);
export {
  u as Layout,
  u as default
};
